import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.taskStoppage;

const taskStoppageData = createSelector([selector], (state) => state);

export default {
  taskStoppageData
};
